import styled from 'styled-components';

export const LabelValidation = styled.label<{ show: boolean }>`
  color: #E53935;
  display: block;
  font-size: .9rem;
  letter-spacing: .02rem;
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
`;
